<template>
  <div class="event-order-card">
    <PortalTarget name="event-order-card" class="z-400" />
    <template v-if="!skeleton">
      <AnalyticsEventWrapper
        v-slot="{ analyticsHandler }"
        tag="div"
        event="change_date_for_tickets"
        event-data="full"
        yandex-metrika
        :event-value="{ placement: 'Выбор билетов' }"
      >
        <EventTimetableCard
          v-if="value"
          :disabled="loading"
          :current-event="value"
          :loading="loading"
          :helpers="['today', 'tomorrow', 'weekend']"
          @event-select="analyticsHandler(), eventSelectHandler($event)"
        />
      </AnalyticsEventWrapper>

      <SchemeCard v-if="isOrderCardVisible" v-bind="{ widgetOrderPayload }" />
    </template>
    <template v-else>
      <EventOrderCardSkeleton />
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { Event, ChangeDatePayload, WidgetOrderPayload } from '@/models'
import { usePriceFilters } from '@/components/Scheme/usePriceFilters'

const props = defineProps({
  value: { type: Object as PropType<Event>, required: true },
  loading: Boolean,
  skeleton: { type: Boolean, default: false },
  widgetOrderPayload: {
    type: Object as PropType<WidgetOrderPayload>,
    required: false,
    default: () => ({}),
  },
})

const emit = defineEmits<{
  (e: 'eventSelect', value: ChangeDatePayload): void
}>()

const { hidePriceFilters } = usePriceFilters()

const eventSelectHandler = (data: ChangeDatePayload) => {
  const { event } = data

  if (!Array.isArray(event)) {
    if (props.value?.id !== event.id) {
      hidePriceFilters()
    }

    if (event.id || event.urlSlug) {
      emit('eventSelect', data)
    }
  }
}

const { isMdAndDown } = useBreakpoints()
const isOrderCardVisible = ref(true)

/**
 * Проверяет ширину экрана, чтобы рендерить/не рендерить SchemeCard
 * для избежания дублирования порталов
 */
const checkWindowWidth = () => {
  const windowWidth = window.innerWidth

  isOrderCardVisible.value = !isMdAndDown(windowWidth)
}

onMounted(() => {
  checkWindowWidth()
  window.addEventListener('resize', checkWindowWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkWindowWidth)
})
</script>
